
export default function parseAddress(gmapResults, key, shortName = false) {
    const address = gmapResults[0];

    var result = '';
    
    // Handle both old geocoding API and new Places API formats
    const components = address.addressComponents || address.address_components;
    
    if (!components) {
        console.warn('No address components found in:', address);
        return result;
    }
    
    components.forEach((component) => {
        let index = component.types.indexOf(key);
        if (index > -1) {
            // Handle both old geocoding API and new Places API formats
            result = shortName ? 
                (component.shortText || component.short_name) : 
                (component.longText || component.long_name);
        }
    });

    return result;
}